import { PresetOptionData } from 'presets';

const MICRO_ENTREPRENEUR: PresetOptionData = {
    label: 'Micro-entrepreneur',
    value: 'Micro-entrepreneur',
};

const ENTREPRISE_INDIVIDUELLE: PresetOptionData = {
    label: 'Entreprise individuelle',
    value: 'Entreprise individuelle',
};

const EIRL: PresetOptionData = {
    label: 'EIRL',
    value: 'EIRL',
};

const EURL: PresetOptionData = {
    label: 'EURL',
    value: 'EURL',
};

const SARL: PresetOptionData = {
    label: 'SARL',
    value: 'SARL',
};

const LEGAL_STATUS_SA: PresetOptionData = {
    label: 'SA',
    value: 'SA',
};

const SAS: PresetOptionData = {
    label: 'SAS',
    value: 'SAS',
};

const SASU: PresetOptionData = {
    label: 'SASU',
    value: 'SASU',
};

const AUTRE: PresetOptionData = {
    label: 'Autre',
    value: 'Autre',
};

export const OPTIONS_FOR_LEGAL_STATUS: ReadonlyArray<PresetOptionData> = [
    MICRO_ENTREPRENEUR,
    ENTREPRISE_INDIVIDUELLE,
    EIRL,
    EURL,
    SARL,
    LEGAL_STATUS_SA,
    SAS,
    SASU,
];

export const OPTIONS_FOR_LEGAL_STATUS_SHORT: ReadonlyArray<PresetOptionData> = [
    MICRO_ENTREPRENEUR,
    ENTREPRISE_INDIVIDUELLE,
    EURL,
    AUTRE,
];

export const OPTIONS_FOR_MICRO_ENTREPRENEUR: ReadonlyArray<PresetOptionData> = [
    MICRO_ENTREPRENEUR,
    ENTREPRISE_INDIVIDUELLE,
    SASU,
    EURL,
];
